import React, { Component } from "react";
import { Typography, Spin, notification, Modal, Button } from "antd"; // Input, Popover,
// import { SearchOutlined } from "@ant-design/icons";
// import ReadMoreReact from "read-more-react";
import { connect } from "react-redux";

import { history } from "../../history";
import axiosGlobal from "../../axios-global";
import { getAPIUrl } from "../../configs/global_var";
import ModalLogin from "../../components/modalLogin/index.js";
import Setting from "../Setting/index.js";
import Psikogram from "./FormDataPdf";
import CardMyApp from "./indexCard";

import "../../assets/css/publish.css";
import "../../assets/css/modal.css";
// import "../../assets/css/utility.css";

const { Text } = Typography;
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [],
      dataA: [],
      dataPublishById: {},
      payment_type: null,
      is_paid: null,
      // modalLogin: false,
      modalApply: false,
      publish_id: null,
      publish_name: null,
      institute: null,
      modal: false,
      participantId: null,
      // isAdmin: true,
      isAdmin: false,
      logo: "",
    };
  }

  componentDidMount() {
    if (this.props.token === null) {
      history.push("/ecommerce/home");
      window.location.reload();
    }
    this.fetchPublish();
  }

  fetchPublish() {
    this.setState({ loading: true });
    axiosGlobal().then((axios) => {
      axios
        .post("/landing/publish/get", { token: this.props.token })
        .then((res) => {
          console.log(res.data.data);
          this.setState({ data: res.data.data });
          // const dataA = res.data.data.filter(v => this.fetchDataPsikogram(v) !== true)
          // this.setState({ dataA: dataA})
        })
        .catch((err) => {
          // if (err.message === "Network Error") {
          //   this.toastError(
          //     "Gagal mengambil data lembaga, silahkan periksa koneksi anda"
          //   );
          // } else {
          //   this.toastError(
          //     "Gagal mengambil data lembaga, silahkan coba beberapa saat lagi"
          //   );
          // }
        })
        .then(() => this.setState({ loading: false }));
    });
  }
  closeModal = (type) => {
    if (type === "login") {
      this.setState({ modalLogin: false });
    } else if (type === "apply") {
      this.setState({ modalApply: false });
    }
  };
  start = async (data) => {
    const entranceUrl = await getAPIUrl();
    const newWindow = window.open(
      `${entranceUrl[0].entrance_url}pages/login?email=${data.participantId}&password=${data.password}&ecommerceUrl=${window.location.hostname}`,
      "_self",
      "noopener,noreferrer"
    );
    if (newWindow) newWindow.opener = null;
  };

  startInAdvance = (data) => {
    console.log(data);
    axiosGlobal().then((axios) => {
      axios
        .post("/paid/checker", {
          token: this.props.token,
          publishId: data.publish_id,
        })
        .then(async (res) => {
          // if (data.is_paid) {
          // ntar pake data paid/checeker bukan yg dr data.is_paid
          const entranceUrl = await getAPIUrl();
          const newWindow = window.open(
            `${entranceUrl[0].entrance_url}pages/login?email=${data.participantId}&password=${data.password}&ecommerceUrl=${window.location.hostname}`,
            "_self",
            "noopener,noreferrer"
          );
          if (newWindow) newWindow.opener = null;
          // } else {
          //   this.clickedMidtrans(data);
          // }
        })
        .catch((err) => {
          if (err.response.status === 400) {
            this.clickedMidtrans(data);
          } else if (err.response.status === 401) {
            this.openNotification(
              "Session Anda telah berakhir, silakan login kembali",
              false
            );
          }
          // else if (err.response.status === 400) {
          // err.response.message ===
          // "your account not activated, please contact admin"
          // this.openNotification(
          //   "Akun anda belum diaktivasi, silahkan hubungi admin",
          //   false
          // );
          // this.clickedMidtrans(data);
          // }
        });
    });
  };

  openModal = (data) => {
    this.setState({
      modalApply: true,
      publish_name: data.publish_name,
      publish_id: data.publish_id,
      participantId: data.participantId,
      dataPublishById: data,
    });
  };

  closeModal = (type) => {
    if (type === "apply") {
      this.setState({
        modalApply: false,
        publish_name: null,
        publish_id: null,
      });
    }
  };

  confirmationPdf = (data) => {
    this.openModal(data);
  };

  clickedMidtrans = (data) => {
    console.log(data);
    axiosGlobal().then((axios) => {
      axios
        .post(`/payment/tokenOnly`, {
          token: this.props.token,
          publishId: data.publish_id,
        })
        .then((res) => {
          console.log(res.data);
          window.snap.pay(res.data.transactionToken);
          // setDataPublish(res.data.data);
          // setLoading(false);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.openNotification(
              "Session Anda telah berakhir, silakan login kembali",
              false
            );
          }
        });
    });
  };

  psikogram = (data) => {
    this.setState({
      participantId: data.participantId,
      payment_type: data.payment_type,
      is_paid: data.is_paid,
      modal: true,
    });
  };

  /*Not Used*/
  apply() {
    axiosGlobal().then((axios) => {
      axios
        .post("/landing/publish/enroll", {
          token: this.props.token,
          publishId: this.state.publish_id,
        })
        .then((res) => {
          this.openNotification("Berhasil menambahkan data", true);
          this.setState({ modalApply: false });
        })
        .catch((err) => {
          if (err.message === "Network Error") {
            this.openNotification(
              "Gagal mengambil data , silahkan periksa koneksi anda",
              true
            );
          } else {
            this.openNotification("Gagal menambahkan data", false);
          }
        })
        .then(() => this.setState({ loading: false }));
    });
  }
  /*Not Used*/

  buttonClickedHandler = () => {
    this.setState({ modalLogin: !this.state.modalLogin });
  };

  openNotification = (msg, status) => {
    const args = {
      message: msg,
      duration: 3,
      className: status ? "notif-succes" : "notif-faild",
    };
    notification.open(args);
  };

  fetchDataPsikogram = (v) => {
    const params = {
      participantId: v.participantId,
      token: this.props.token,
    };

    try {
      axiosGlobal().then((axios) => {
        axios.post("/psikogram/pdf", params).then((res) => {
          if (!res.data.data.length) {
            return false;
          } else {
            return true;
          }
        });
      });
    } catch (err) {
      return false;
    }
  };

  render() {
    const {
      loading,
      data,
      modalLogin,
      modalApply,
      publish_name,
      institute,
      participantId,
      dataPublishById,
      payment_type,
      is_paid,
    } = this.state;
    return (
      <>
        {this.state.isAdmin ? (
          <Setting logo={this.state.logo} />
        ) : (
          <main className="container-content my-app">
            <section className="content-publish">
              {loading ? (
                <Spin
                  className="loading"
                  style={{ marginTop: "40vh", marginBottom: "59vh" }}
                />
              ) : (
                <>
                  {/* this.state.dataA */}
                  {data.length === 0 ? (
                    <div className="text-center">
                      <p className="font-center"> No Data yet </p>
                    </div>
                  ) : (
                    data.map((v, i) => (
                      <div className="card-publish my-app" key={i}>
                        {/* fetchDataPsikogram={this.fetchDataPsikogram} */}
                        <CardMyApp
                          v={v}
                          onPsikogram={this.psikogram}
                          onStart={this.start}
                          onStartInAdvance={this.startInAdvance}
                          onConfirmationPdf={this.confirmationPdf}
                        />
                        {/* // onClick={() => this.psikogram(this.props.v)} */}
                        {/* // onClick={() => this.start(this.props.v)} */}
                      </div>
                    ))
                  )}
                  {/* <p>masih progress</p> */}
                </>
              )}

              {/* modal */}
              <div
                className={
                  modalApply
                    ? "modal-container-active column"
                    : "modal-container-inactive"
                }
                onClick={() => this.closeModal("apply")}
              >
                <div
                  className="modal-body sm"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <div
                    style={{ marginBottom: "1rem" }}
                    className="font-bold width font-32 font-serif"
                  >
                    <h3>Confirmation</h3>
                  </div>
                  <div className="font-center width font-24 font-serif font-space-1">
                    <h5>{`Your psikogram is still in limited mode. Are you sure want to open it?`}</h5>
                  </div>
                  <div className="btn-container">
                    <Button
                      className="button-cancel"
                      style={{ margin: "4px" }}
                      onClick={() => this.psikogram(dataPublishById)}
                    >
                      <h5
                        style={{ color: "#7367f0", margin: "auto" }}
                        className="cancel"
                      >
                        Open
                      </h5>
                    </Button>
                    <Button
                      className="button-apply"
                      style={{ margin: "4px" }}
                      onClick={() => this.clickedMidtrans(dataPublishById)}
                    >
                      <h5 style={{ color: "#fff", margin: "auto" }}>Payment</h5>
                    </Button>
                  </div>
                </div>
              </div>
            </section>
            <div>
              <ModalLogin
                isOpen={modalLogin}
                buttonClicked={this.buttonClickedHandler}
                onClose={() => this.closeModal("login")}
              />
            </div>
            <Modal
              title="Psikogram"
              visible={this.state.modal}
              onCancel={() => this.setState({ modal: false })}
              width={800}
              footer={false}
            >
              <Psikogram
                participantId={participantId}
                payment_type={payment_type}
                is_paid={is_paid}
                token={this.props.token}
              />
            </Modal>
          </main>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.login.token,
  };
};

export default connect(mapStateToProps, null)(Index);
